class FetchAccountRoles {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default FetchAccountRoles;
